/**
 * Coordinates post-auth default landing with HierarchicalHeader's first-tab redirect.
 * While phase is `checking`, the header should not replace `/` with the first tab.
 */
import { useSyncExternalStore } from 'react';

/** @typedef {'idle' | 'checking' | 'done'} LandingGatePhase */

/** @type {LandingGatePhase} */
let phase = 'idle';
const listeners = new Set();
const notify = () => {
  listeners.forEach(listener => listener());
};
export const getLandingGateSnapshot = () => phase;
export const subscribeLandingGate = listener => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
export const shouldDeferFirstTabRedirect = () => phase === 'checking';
export const startLandingCheck = () => {
  phase = 'checking';
  notify();
};
export const finishLandingCheck = () => {
  phase = 'done';
  notify();
};
export const resetLandingGate = () => {
  phase = 'idle';
  notify();
};

/** Subscribe in header so first-tab redirect re-runs when the gate opens. */
export const usePostAuthLandingGate = () => useSyncExternalStore(subscribeLandingGate, getLandingGateSnapshot, getLandingGateSnapshot);